<div class="px-2 mt-[5%] mb-[5%] lg:mt-[15%] lg:mb-[30%]">
  <div class="bg-[#EEF4F5] rounded-xl px-4 py-5 text-center shadow-sm">
    <!-- Icon -->
    <div class="flex justify-center mb-1">
      <wu-icon name="shareFeedbackIcon"></wu-icon>
    </div>

    <!-- Text -->
    <p class="text-[14px] text-[#444] mb-1">We'd love to hear from you.</p>

    <!-- Link-style button -->
    <button
      class="text-[14px] font-semibold text-[#00334C] border-b-2 border-[#004B65] pb-0.5 leading-none"
      (click)="goToQualtricks()"
    >
      Share Feedback
    </button>
  </div>
</div>
